import { FC, useCallback, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { WorkspacesFiltersFormModel } from 'lib/forms/WorkspacesFiltersFormUtils'
import { selectActiveWorkspace } from 'lib/helpers/selectors'
import ManagementWorkspacesAdvancedFilters from '../ManagementWorkspacesAdvancedFilters/ManagementWorkspacesAdvancedFilters'
import ManagementWorkspaceSimpleFilters from '../ManagementWorkspacesSimpleFilters/ManagementWorkspaceSimpleFilters'
import { useAppSelector } from 'store/hooks'
import { useManagementWorkspacesContext } from 'components/Management/ManagementWorkspaces/ManagementWorkspacesContextProvider/ManagementWorkspacesContextProvider'
import './styles.scss'

const WorkspacesFiltersForm: FC = () => {
  const { fetchManagementWorkspaces, updateManagementWorkspacesState } =
    useManagementWorkspacesContext()

  const activeWorkspace = useAppSelector(selectActiveWorkspace)

  const methods = useFormContext()

  const [isAdvanceSearch, setIsAdvanceSearch] = useState<boolean>(false)
  const { setValue } = methods

  const onSubmit = useCallback(
    (data: WorkspacesFiltersFormModel) => {
      fetchManagementWorkspaces()
      updateManagementWorkspacesState({ stableFilters: data })
    },
    [fetchManagementWorkspaces, updateManagementWorkspacesState]
  )

  const handleResetForm = useCallback(() => {
    setValue('param', '')
    setValue('workspace-status', undefined)
    setValue('closing-status', undefined)
    setValue('team', undefined)
    setValue('opinion', undefined)
    setValue('plan', undefined)
    setValue('coefficient', undefined)
    setValue('expiration-e', undefined)
    setValue('expiration-csd', undefined)
    setValue('profiling', undefined)
    fetchManagementWorkspaces()
    updateManagementWorkspacesState({ stableFilters: {} })
  }, [fetchManagementWorkspaces, setValue, updateManagementWorkspacesState])

  const handleAdvancedSearchActive = useCallback(() => {
    if (isAdvanceSearch === true) {
      handleResetForm()
      setIsAdvanceSearch(value => !value)
    } else {
      setIsAdvanceSearch(value => !value)
    }
  }, [isAdvanceSearch, handleResetForm])

  useEffect(() => {
    handleResetForm()
    setIsAdvanceSearch(false)
  }, [activeWorkspace, handleResetForm])

  return (
    <form
      className="management-workspaces-filters-form"
      onSubmit={methods.handleSubmit(onSubmit)}>
      <ManagementWorkspaceSimpleFilters
        isAdvancedSearchActive={isAdvanceSearch}
        handleAdvancedSearch={handleAdvancedSearchActive}
        handleResetForm={handleResetForm}
      />
      {isAdvanceSearch && (
        <ManagementWorkspacesAdvancedFilters
          handleResetForm={handleResetForm}
        />
      )}
    </form>
  )
}

export default WorkspacesFiltersForm
